module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Underdog-2007.52972e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Underdog-2007.jpg
// module id = 4/3j
// module chunks = 0